module.exports = __webpack_public_path__ + "static/img/4.498d42f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/4.png
// module id = E4sb
// module chunks = 0